/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
const deepLinkFlag = 'deeplink';
export class FirebaseRpcBackend {
    get user() {
        this.validateUser();
        return this._user;
    }
    constructor(adapter) {
        this.adapter = adapter;
    }
    async init() {
        // sign in anonymously, if not authed
        if (this._user) {
            return;
        }
        this._user = await this.fetchUser();
    }
    relink() {
        return this.adapter.fetchDocumentData(`link/${this.user.uid}/result/data`);
    }
    send(payload, canSendNotification) {
        return this.adapter.callHttps('sign', { payload, canSendNotification });
    }
    async signOut() {
        await this.adapter.signOut();
        this._user = undefined;
    }
    async watchLink() {
        const result = await this.adapter.watchDocumentData(`link/${this.user.uid}/result/data`);
        if (!result) {
            return Promise.reject('Link failed');
        }
        return result;
    }
    async watchSignedMessage(docId) {
        const documentPaths = {
            root: `sign/${docId}`,
            result: `sign/${docId}/result/data`,
            payload: `sign/${docId}/payload/data`
        };
        const result = await this.adapter.watchDocumentData(documentPaths.result);
        if (!result) {
            return Promise.reject('Sign result not found');
        }
        // delete documents about this sign
        await this.adapter.deleteDocument(documentPaths.result);
        await this.adapter.deleteDocument(documentPaths.payload);
        await this.adapter.deleteDocument(documentPaths.root);
        if (result.error) {
            return Promise.reject(result.error);
        }
        return result;
    }
    async setDeepLink() {
        await this.adapter.setUserDisplayName(deepLinkFlag);
        this._user = await this.fetchUser();
    }
    async fetchUser() {
        const { uid, displayName } = await this.adapter.user || await this.adapter.signInAnonymously();
        return {
            uid,
            isDeepLink: Boolean(displayName && displayName.startsWith(deepLinkFlag))
        };
    }
    validateUser() {
        if (!this._user) {
            throw new Error('not initialized');
        }
    }
}
